import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled from 'styled-components';
const Container = styled.button `
  ${ButtonReset}

  ${transition('background-size, color')}

  display: inline-flex;
  color: var(--colorFg);
  background-color: var(--colorBg);
  background-image: linear-gradient(to right, var(--colorBgActive), var(--colorBgActive));
  background-repeat: no-repeat;
  background-size: var(--bgSize);
  border: 1px solid var(--colorBorder);
  border-radius: ${38 / 2}px;
  ${fonts.altGothicNo2.regular}
  font-size: 20px;
  height: 38px;
  line-height: 1em;
  padding: 0px 20px;
  place-content: center;
  place-items: center;
  text-transform: uppercase;

  @media (hover: hover) or (pointer: fine) {
    &:hover {
      background-size: var(--bgSizeActive);
      border-color: var(--colorBorderActive);
      color: var(--colorFgActive);
    }
  }

  &[aria-current='true'] {
    background-size: var(--bgSizeActive);
    border-color: var(--colorBorderActive);
    color: var(--colorFgActive);
  }

  &[data-theme='light'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.black};
    --colorBg: ${brand.white};
    --colorBorder: ${brand.black};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.black};
  }

  &[data-theme='dark'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.yellow};
    --colorBg: ${brand.black};
    --colorBorder: ${brand.yellow};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.yellow};
  }

  &[data-theme='outline'] {
    --bgSize: 0% 100%;
    --colorFg: ${brand.white};
    --colorBg: transparent;
    --colorBorder: ${brand.white};

    --bgSizeActive: 100% 100%;
    --colorFgActive: ${brand.black};
    --colorBgActive: ${brand.yellow};
    --colorBorderActive: ${brand.yellow};
  }

  &.focus-ring {
    outline: auto;
    outline-color: ${brand.white};
    outline-offset: 5px;
    outline-width: thin;
  }
`;
const TabButtonStyles = {
    Container,
};
export default TabButtonStyles;
